import Head from 'next/head';
import { Suspense, useEffect } from 'react';
import { GoogleTagManager } from '@next/third-parties/google';
import { Loader } from '../components/common';
import { Provider } from 'react-redux';
import { ErrorBoundary } from '../components/common';
import { store } from '../lib/store';
import { loadFonts } from '../utils/hooks/useFonts';
// import { WhatsAppFloatingIcon } from '../components/common';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../styles/globals.css';
import { safeRequestIdleCallback } from '../utils/helpers/utils';
import { onConsentAccept, onConsentDecline } from '../utils/services/cookiebotService';

const GTM_ID = process.env.NEXT_PUBLIC_GTM_ID;

function Hirego({ Component, pageProps }) {
    useEffect(() => {
        // Load all fonts progressively after page load
        const loadFontsAfterPageLoad = () => {
            try {
                // Also load the CSS file for immediate use
                loadFonts();
            } catch (error) {
                // console.error('Error loading fonts:', error);
            }
        };
        
        // Safari-safe font loading
        safeRequestIdleCallback(loadFontsAfterPageLoad, {});

        // Add error handling for unhandled promise rejections
        const handleUnhandledRejection = (event) => {
            // console.error('Unhandled promise rejection:', event.reason);
        };

        window.addEventListener('unhandledrejection', handleUnhandledRejection);

        return () => {
            window.removeEventListener('unhandledrejection', handleUnhandledRejection);
        };
    }, []);

    // Initialize Cookiebot consent handlers
    // Note: Cookiebot script is loaded via GTM, we just handle the consent events
    useEffect(() => {
      if (typeof window === "undefined") return

      // Delay subscription to ensure Cookiebot is loaded from GTM
      // Match Angular's 1500ms delay
      const cookiebotTimer = setTimeout(() => {
        // Subscribe to consent events (Cookiebot loaded via GTM)
        onConsentAccept((consent) => {
          // Optional: Track consent acceptance in GTM
          if (window.dataLayer) {
            window.dataLayer.push({
              event: 'cookiebot_consent_accept',
              consent: consent
            })
          }
        })

        onConsentDecline((consent) => {
          // Optional: Track consent decline in GTM
          if (window.dataLayer) {
            window.dataLayer.push({
              event: 'cookiebot_consent_decline',
              consent: consent
            })
          }
        })
      }, 1500)

      return () => {
        clearTimeout(cookiebotTimer)
      }
    }, [])
    

    return (
        <ErrorBoundary>
            <Provider store={store}>
                {GTM_ID ? <GoogleTagManager gtmId={GTM_ID} /> : null}
                <Head>
                    <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no" />
                    <meta name="google-site-verification" content={process.env.NEXT_PUBLIC_GOOGLE_SITE_VERIFICATION} />
                    
                </Head>
                
                {/* Skip Links for Accessibility */}
                <a href="#main-content" className="skip-link">Skip to main content</a>
                <a href="#navigation" className="skip-link" style={{ top: '-88px' }}>Skip to navigation</a>
                
                <main id="main-content" role="main">
                    <Suspense fallback={<Loader type="page" message="Loading..." fullPage={true} />}>
                        <Component {...pageProps} />
                    </Suspense>
                </main>
                
                {/* Global WhatsApp Floating Icon */}
                {/* <WhatsAppFloatingIcon 
                    phoneNumber="+447488884496" 
                    message="Hello! I'm interested in your services. Can you help me?"
                /> */}
            </Provider>
        </ErrorBoundary>
    );
}

export default Hirego;
